import React, { Component } from 'react';
import { CheckCircleOutlined, CloseCircleFilled, CloseCircleOutlined, EditOutlined, LoadingOutlined } from '@ant-design/icons';
import { Select, Spin, Radio, Tooltip } from 'antd';
import Panel from '@/components/Panel';
import { createPortal } from 'react-dom';
import { getPanelMaxWidth, getPanelWidth, getPanelMaxHeight } from '@/services/helper/panelSizeHelper';
import './index.css';
import { getCascadeCSMCPMSpiceModelList } from '../../services/Cascade/library';
import { getWriteAndReadPortList } from '../../services/LibraryHelper/SpiceModelHelper/csmCpmParseHelper';
import CPMConnection from '../CPMCSMSetup/CPMConnection';
import auroraDBJson from '../../services/Designs/auroraDbData';
import { getDiePortsByPloc } from '../../services/helper/portCanvasHelper';
import EditableTable from '../EditableTable';

const NONE = 'None', SUCCESS = 'Success', ERROR = 'Error', LOADING = 'Loading'
const CENTER = 'center', SINGLE = 'single'
const columns = [{
  title: 'Port',
  dataIndex: 'port',
  width: '20%'
},
{
  title: 'Power Pins Group',
  dataIndex: 'portName',
  width: '40%'
}, {
  title: 'Reference Pins Group',
  dataIndex: 'referenceGroup',
  width: '40%',
}];
class PlocSetupPanel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      maxWidth: 300,
      maxHeight: 100,
      plocSelectFile: {},
      connectionVisible: false,
      cpmPairs: [],
      autoMatchStatus: NONE,
      autoMatchSpan: '',
      loading: false,
      pinMatching: CENTER,
      ports: [],
      powerGroupsList: [],
      referenceGroupsList: [],
      tableLoading: false
    }
    this.dialogRoot = document.getElementById('root');

    columns[1].render = (text, record) => {
      return <div className='ploc-group-column'>
        <Tooltip
          title={text}
          classNames={{ root: 'aurora-tooltip' }}
        >
          <span>{text}</span>
        </Tooltip>
      </div>
    }

    columns[2].render = (text, record) => {
      return <div className='ploc-group-column'>
        <Tooltip
          title={text}
          classNames={{ root: 'aurora-tooltip' }}
        >
          <span>{text}</span>
        </Tooltip>
      </div>
    }

    columns[2].onCell = (record) => {
      const { referenceGroupsList } = this.state;
      return {
        record,
        edit: "select",
        options: referenceGroupsList.map(item => item.name),
        dataIndex: "referenceGroup",
        getPopupContainer: document.getElementById('root'),
        handleSave: (_record) => { this.editPort(_record) }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxWidth: getPanelMaxWidth(offset, 300),
      maxHeight: getPanelMaxHeight(offset, 100)
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
    this.initData()
  }

  initData = async () => {
    const { plocInfo } = this.props;
    const _plocInfo = JSON.parse(JSON.stringify(plocInfo || {}));
    this.setState({
      plocInfo: _plocInfo,
      cpmPairs: _plocInfo.cpmPairs || [],
      triPairs: _plocInfo.triPairs || [],
      transforms: _plocInfo.transforms || null,
      plocSelectFile: _plocInfo.plocSelectFile,
      pinMatching: _plocInfo.pinMatching || CENTER,
      ports: _plocInfo.ports || []
    }, () => {
      if (_plocInfo.plocSelectFile && _plocInfo.plocSelectFile.libraryId)
        this.changeSelectPLOCModel(_plocInfo.plocSelectFile.libraryId, false, false)
    })
  }

  closeModal = () => {
    this.setState({
      loading: true,
      autoMatchStatus: NONE,
      autoMatchSpan: ''
    }, () => {
      setTimeout(() => {
        const { plocSelectFile, cpmPairs, triPairs, transforms, ports, pinMatching } = this.state
        this.props.savePlocInfo({ plocSelectFile, cpmPairs, triPairs, transforms, pinMatching, ports })
        this.props.savePlocPorts(ports)
        this.props.closeModal(false);
      }, 100)
    })
  }

  changeSelectPLOCModel = (value, updatePairs = true, updatePorts = true) => {
    const { plocModelList } = this.props
    const currentFile = plocModelList.find(item => item.id === value)
    if (currentFile) {
      const { id, name } = currentFile
      let updateFileInfo = { libraryId: id, fileName: name };
      if (updatePairs) {
        this.setState({
          cpmPairs: [],
          triPairs: [],
          transforms: null,
        })
      }
      this.setState({
        plocSelectFile: updateFileInfo,
        autoMatchStatus: LOADING,
        autoMatchSpan: 'Automatically matching PLOC file content by Pin Number.'
      }, async () => {
        const file = await getCascadeCSMCPMSpiceModelList({ ...updateFileInfo, fileType: 'ploc' });
        this.autoSetPlocByPinNumber(file, updatePorts)
      });
    }
  }

  deletePlocFileSelect = () => {
    this.setState({
      plocSelectFile: {},
      cpmPairs: [],
      autoMatchStatus: NONE,
      autoMatchSpan: '',
      ports: [],
      powerGroupsList: [],
      referenceGroupsList: [],
      triPairs: [],
      transforms: null,
    })
  }

  openCPMConnection = (e, visible) => {
    e && e.stopPropagation();
    this.setState({
      connectionVisible: visible,
    }, () => {
      if (!visible) {
        this.setState({
          autoMatchStatus: NONE,
          autoMatchSpan: ''
        })
      }
    })
  }

  saveCPMPinMapping = ({ cpmPairs, triPairs, transforms, canvasFile, csmPairs }) => {
    this.setState({
      cpmPairs,
      triPairs,
      transforms,
      canvasFile,
      csmPairs
    })
  }

  editPort = (record) => {
    const { ports, referenceGroupsList } = this.state;
    let _ports = JSON.parse(JSON.stringify(ports));
    const index = _ports.findIndex(item => item.port === record.port);
    if (index < 0) {
      return;
    }

    const referenceGroupInfo = referenceGroupsList.find(item => item.name === record.referenceGroup)
    _ports[index].referenceGroup = record.referenceGroup;
    _ports[index].referencePins = referenceGroupInfo && referenceGroupInfo.pins ? [...referenceGroupInfo.pins] : [];
    this.setState({
      ports: _ports
    })
  }

  changePortInfo = (cpmPairs, updatePorts = true) => {
    const { designId, chip, PowerNets, ReferenceNets } = this.props;
    const { pinMatching, ports: _ports } = this.state
    const cpmPins = cpmPairs.filter(item => [...PowerNets, ...ReferenceNets].includes(item.net));
    const { ports, powerGroupsList, referenceGroupsList } = getDiePortsByPloc({
      packageId: designId,
      component: chip,
      PowerNets,
      ReferenceNets,
      cpmPins,
      pinMatching
    })
    this.setState({
      ports: updatePorts ? ports : _ports,
      powerGroupsList,
      referenceGroupsList,
    })
  }

  autoSetPlocByPinNumber = (file, updatePorts) => {
    if (!file || !file.model || !file.model.CPM || !file.model.CPM.models) {
      return;
    }
    const nodes = JSON.parse(JSON.stringify(file.model.CPM.models));
    const { designId, chip } = this.props;
    const chipInfo = auroraDBJson.getComponent(designId, chip);
    if (!chipInfo || !chipInfo.pins) {
      return;
    }
    let cpmPairs = [];
    for (let nodeInfo of nodes) {
      const { net, node, portName } = nodeInfo;
      const pinInfo = chipInfo.pins.get(node);
      if (!pinInfo) {
        continue;
      }
      cpmPairs.push({
        csmNet: net,
        node,
        portName,
        pin: pinInfo.pin,
        net: pinInfo.net
      })
    }

    this.changePortInfo(cpmPairs, updatePorts)

    if (cpmPairs.length / nodes.length > 0.1) {
      this.setState({
        cpmPairs: cpmPairs,
        autoMatchStatus: SUCCESS,
        autoMatchSpan: `${SUCCESS}: Automatic matching is success (By Pin Number), there are ${nodes.length} Nodes in the PLOC file, and ${cpmPairs.length} Nodes are successfully matched. Close the PLOC Setup Options Panel to view the Port grouping.`
      })
    } else {
      this.setState({
        cpmPairs: [],
        autoMatchStatus: ERROR,
        autoMatchSpan: `${ERROR}: Automatic matching failed (By Pin Number). Please edit PLOC Connection to match manually.`
      })
    }
  }

  pinMatchingChange = (e) => {
    const value = e.target.value
    this.setState({
      pinMatching: value,
      tableLoading: true
    }, () => {
      setTimeout(() => {
        const { cpmPairs } = this.state
        this.changePortInfo(cpmPairs)
        this.setState({
          tableLoading: false
        })
      }, 100)
    })
  }

  getPlocMsgClass = () => {
    const { autoMatchStatus } = this.state;
    switch (autoMatchStatus) {
      case SUCCESS:
        return 'port-setup-ploc-success-msg';
      case ERROR:
        return 'port-setup-ploc-error-msg';
      case LOADING:
        return 'port-setup-ploc-loading-msg';
      case NONE:
      default:
        break;
    }
  }

  getPlocMsgIcon = () => {
    const { autoMatchStatus } = this.state;
    switch (autoMatchStatus) {
      case SUCCESS:
        return <CheckCircleOutlined />;
      case ERROR:
        return <CloseCircleOutlined />;
      case LOADING:
        return <LoadingOutlined />;
      case NONE:
      default:
        break;
    }
  }

  render() {
    const { maxWidth, maxHeight, plocSelectFile, connectionVisible, triPairs, transforms, cpmPairs, autoMatchSpan, autoMatchStatus, loading, pinMatching, ports, tableLoading } = this.state;
    const { plocModelList, designId, PowerNets, ReferenceNets, chip, product, autoMatch } = this.props
    const setting = { defaultWidth: 500 }
    const content = (
      <Panel
        className='ploc-setup-panel'
        title={'PLOC Setup Options'}
        onCancel={this.closeModal}
        zIndex={2000}
        width={getPanelWidth(maxWidth, setting)}
        position='panel-center-left'
        draggable
        minWidth={200}
        minHeight={100}
        maxHeight={maxHeight}
      >
        <Spin spinning={loading} tip='Generating Ports...'>
          <div className='ploc-content-body'>
            <div className='ploc-content-item'>
              <span>PLOC Model</span>
              <Select
                className='aurora-select'
                popupClassName="aurora-select-dropdown"
                onSelect={(value) => this.changeSelectPLOCModel(value)}
                value={plocSelectFile && plocSelectFile.libraryId ? plocSelectFile.libraryId : null}
                size='small'
                showSearch={true}
                popupClassNameMatchSelectWidth={false}
                allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => { this.deletePlocFileSelect() }} /> }}
                options={(plocModelList || []).map(item => ({
                  value: item.id,
                  label: item.name,
                }))}
              />
            </div>
            <div className='ploc-content-item'>
              <span>PLOC Connection</span>
              <EditOutlined className='ploc-content-icon' onClick={(e) => this.openCPMConnection(e, true)} />
            </div>
            <div className='ploc-content-item'>
              <span>Pin Matching</span>
              <Radio.Group value={pinMatching} onChange={(e) => this.pinMatchingChange(e)}>
                <Radio value={CENTER}>Center-Based Nearest</Radio>
                <Radio value={SINGLE}>Single Nearest</Radio>
              </Radio.Group>
            </div>
            <EditableTable
              rowKey="port"
              columns={columns}
              size="small"
              dataSource={ports}
              className='ploc-port-table'
              scroll={ports.length > 8 ? { y: 320 } : {}}
              loading={tableLoading}
              tableLayout="fixed"
            />
            {autoMatchStatus !== NONE ? <div className='ploc-content-item'>
              <div className={`port-setup-ploc-msg ${this.getPlocMsgClass()}`}>
                {this.getPlocMsgIcon()}
                {autoMatchSpan}
              </div>
            </div> : null}
          </div>
        </Spin>
        {connectionVisible ? <CPMConnection
          designId={designId}
          component={chip}
          PowerNets={PowerNets}
          ReferenceNets={ReferenceNets}
          selectFile={plocSelectFile}
          triPairs={triPairs}
          transforms={transforms}
          cpmPairs={cpmPairs}
          canvasFile={plocSelectFile}
          closePanel={() => this.openCPMConnection(null, false)}
          saveCPMPinMapping={this.saveCPMPinMapping}
          writeSelectFile={plocSelectFile}
          getPortList={getWriteAndReadPortList}
          isUpdateFile={true}
          modelType={'PLOC'}
          product={product}
          getCSMCPMSpiceModelList={getCascadeCSMCPMSpiceModelList}
          autoMatch={autoMatch}
        /> : null}
      </Panel>
    )
    return createPortal(content, this.dialogRoot)
  }
}

export default PlocSetupPanel;